import { render, staticRenderFns } from "./clickableAreaSelect.vue?vue&type=template&id=adb3ad16&scoped=true&"
import script from "./clickableAreaSelect.vue?vue&type=script&lang=js&"
export * from "./clickableAreaSelect.vue?vue&type=script&lang=js&"
import style0 from "./clickableAreaSelect.vue?vue&type=style&index=0&id=adb3ad16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb3ad16",
  null
  
)

export default component.exports